// src/hooks/vfkbToJson.js
export default function vfkbToJson(text) {
  let json = {};
  text.split(";").forEach(entry => {
    const [key, ...rest] = entry.split(":");
    if (key && rest.length > 0) {
      const cleanedKey = key.trim();
      const cleanedValue = rest.join(":").trim();
  
      // Si la valeur semble contenir une liste (séparée par des virgules), transformer en tableau
      if (cleanedValue.includes(",") && !cleanedValue.includes(" :")) {
        json[cleanedKey] = cleanedValue.split(",").map(v => v.trim());
      } else {
        json[cleanedKey] = cleanedValue;
      }
    }
  });

  return json;
}
